import Navbar from './components/Navbar';
import Hero from './components/Hero';
import KLTransportProblem from './components/KLTransportProblem';
import Features from './components/Features';
import VerifiedCommunity from './components/VerifiedCommunity';
import Leadership from './components/Leadership';
import LaunchPlan from './components/LaunchPlan';
import Investors from './components/Investors';
import GlobalLicensing from './components/GlobalLicensing';
import Waitlist from './components/Waitlist';
import ContactUs from './components/ContactUs';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <KLTransportProblem />
      <Features />
      <VerifiedCommunity />
      <Leadership />
      <LaunchPlan />
      <Investors />
      <GlobalLicensing />
      <Waitlist />
      <ContactUs />
      <Footer />
    </div>
  );
}
